import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tz/go/egaz/osci/ptl/comn";

/*
 *  Approval Management Service
 * !== 결재 관리 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/comnmdle/aprv`,
    api: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/ptl/aprv/aprv-mgmt`,
    nodes: [{ label: "Portal" }, { label: "Common Module" }, { label: "Approval Management" }],
};

export const URLS = {
    osci0108004q: `${BASE.path}/osci0108004q`, // Approval Status List   !== 결재 현황 목록 ==!
    osci0108005s: `${BASE.path}/osci0108005s`, // Approval Detail        !== 결재 상세 화면 조회 ==!
};

// Approval Status Code !== 결재 상태 코드 값 (승인,반려) ==!
const lastAprvYn = [
    { label: "Approved", value: "Y" },
    { label: "Returned", value: "P" },
    { label: "Rejected", value: "N" },
];

export const APIS = {
    // View Approval Waiting Status List !== 결재 대기 상태 목록 조회 ==!
    getAprvWaitList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/wait?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // View Approval in Progress Status List !== 결재 진행중 상태 목록 조회 ==!
    getAprvPrcdList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/prcd?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // View Approval Completion Status List !== 결재 완료 상태 목록 조회 ==!
    getAprvCmptList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/cmpt?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // View Approval Request Status List !== 결재 요청 상태 목록 조회 ==!
    getAprvRqstList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/rqst?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // View Approval History List !== 결재 이력 목록 조회 ==!
    getAprvHistList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/hist?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // View Approval Request Information !== 결재 요청 정보 조회 ==!
    getAprvRqstInfo: (data: any) => {
        return api.get(`${BASE.api}/rqst/${data.aprvId}/${data.usrDmnId}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // View Approval History Information !== 결재 이력 정보 조회 ==!
    getAprvHistInfo: (data: any) => {
        return api.get(`${BASE.api}/histInfo/${data.aprvId}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Save Approval Processing Information !== 결재 처리 정보 저장 ==!
    saveAprvPrcsInfo: (data: any) => {
        return api.put(`${BASE.api}/prcss`, {
            ...data,
        });
    },
    // Save Approval Cancle Processing Information !== 결재 요청 취소 저장 ==!
    saveAprvCnclInfo: (data: any) => {
        return api.put(`${BASE.api}/cncl`, {
            ...data,
        });
    },
    // Update Approval Officer Information !== 결재자 수정 ==!
    updateAprvOfcrInfo: (data: any) => {
        return api.post(`${BASE.api}/aprvOfcr`, {
            ...data,
        });
    },
    // get Customs Officer Match Count !== 세관직원 일치 count 조회 ==!
    getCstmOfcrMtchCnt: (data: any) => {
        return api.post(`${BASE.api}/mtchCnt`, {
            ...data,
        });
    },
    // get Organization User List !== 기관 사용자 목록 조회 ==!
    getOrgUsrList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/org/usr?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
};

// Approval Status Search Form !== 결재 현황 검색 폼 ==!
export const SF_APRV_STAT_SRCH: TFormSchema = {
    id: "form_aprvStatSrch",
    schema: {
        frstRgsrDtmRnge: {
            type: "daterange",
            label: "L_RQST_PRID",
            start: { name: "aprvRqstStrtDt" },
            end: { name: "aprvRqstEndDt" },
            rangeButton: 0,
        },
        aprvDocClsf: {
            // !== 신고 문서 코드에 따라 결재 문서 종류 보여주기 ==!
            type: "select",
            label: "L_APRV_DOC_CLSF",
            all: true,
            area: "comnCd",
            comnCd: "OSC0092",
        },
        aprvPrcssStatCd: { type: "select", label: "L_PRCSS_STTS", all: true, area: "comnCd", comnCd: "OSC0096" },
        aprvRqstTtleNm: { type: "text", label: "L_APRV_RQST_TTLE_NM" },
        bsopClsfCd: {
            type: "select",
            label: "L_BSOP_CLSF_CD",
            all: false,
            area: "comnCd",
            comnCd: "OSC0088",
            select: false,
            defaultValue: "OSC",
        },
        aprvRqstUsrNm: { type: "text", label: "L_APRV_USR_NM" },
        docNo: { type: "text", label: "L_DOC_NO" },
        aprvChgAuthYn: { type: "text", label: "" },
    },
};

// Approval Request Form !== 결재 요청 폼 ==!
export const SF_APRV_RQST_INFO: TFormSchema = {
    id: "form_aprvRqstInfo",
    schema: {
        aprvId: { type: "text", label: "L_APRV_ID" },
        afPrcssUrlAddr: { type: "text", label: "L_AF_URL_ADDR" },
        aprvPrcssOrd: { type: "text", label: "L_APRV_PRCSS_ORD" },
        aprvRqstTtleNm: { type: "text", label: "L_APRV_RQST_TTLE_NM" },
        aprvRqstCn: { type: "textarea", label: "L_APRV_RQST_CN" },
        aprvPrcssStatCd: { type: "text", label: "L_APRV_PRCSS_STAT_CD" },
        aprvPrcssStatCdNm: { type: "text", label: "L_APRV_PROC_STAT" },
        bsopClsfCd: { type: "text", label: "L_BSOP_CLSF_CD" },
        usrNm: { type: "text", label: "L_RQST_USER_NM" },
        aprvRqstDtm: { type: "datetime", label: "L_APRV_RQST_DT" },
        docNm: { type: "text", label: "L_APRV_DOC_NM" },
        docMakeUrlAddr: { type: "text", label: "L_DOC_MAKE_URL_ADDR" },
        aprvReffId: { type: "text", label: "L_DOC_MAKE_URL_ADDR" },
        scrnDocCd: { type: "text", label: "" },
        grpAprvYn: { type: "text", label: "" },
        aprvPrcssOpinCn: { type: "text", label: "L_APRV_PRCS_OPIN_CN" },
    },
};

// Approval Request Popup Form !== 결재 요청 팝업 폼 ==!
export const SF_APRV_RQST_PPUP_INFO: TFormSchema = {
    id: "form_aprvRqstPpupInfo",
    schema: {
        aprvId: { type: "text", label: "L_APRV_ID" },
        aprvPrcssPathMgmtId: { type: "text", label: "L_APRV_PRCSS_PATH_MGMT_ID" },
        aprvRqstTtleNm: { type: "text", label: "L_APRV_RQST_TTLE_NM" },
        aprvRqstCn: { type: "textarea", label: "L_APRV_RQST_CN", required: true, controlSize: 10, maxLength: 200 },
        aprvPrcssStatCd: { type: "text", label: "L_APRV_PRCSS_STAT_CD" },
        bsopClsfCd: { type: "text", label: "L_BSOP_CLSF_CD" },
        usrDmnId: { type: "text", label: "L_USR_DMN_ID" },
        aprvRqstDtm: { type: "text", label: "L_APRV_RQST_DT" },
        scrnDocCd: { type: "text", label: "L_APRV_RQST_DT" },
        cstmOfceCd: { type: "text", label: "L_CSTM_OFCE_CD" },
    },
};

// Approval Document Form !== 결재 문서 폼 ==!
export const SF_APRV_DOC_INFO: TFormSchema = {
    id: "form_aprvDocInfo",
    schema: {
        aprvId: { type: "text", label: "L_APRV_ID" },
        aprvPrcssPathMgmtId: { type: "text", label: "L_APRV_PRCSS_PATH_MGMT_ID" },
        aprvRqstTtleNm: { type: "text", label: "L_APRV_RQST_NM" },
        aprvRqstCn: { type: "textarea", label: "L_APRV_RQST_CN", rows: 3, controlSize: 10 },
        aprvPrcssStatCd: { type: "text", label: "L_APRV_PRCSS_STAT_CD" },
        bsopClsfCd: { type: "text", label: "L_BSOP_CLSF_CD" },
        usrDmnId: { type: "text", label: "L_USR_DMN_ID" },
        aprvPrcssMetdCd: { type: "text", label: "L_APRV_PRCSS_METD_CD" },
        usrNm: { type: "text", label: "L_RQST_USER_NM" },
        aprvRqstDtm: { type: "text", label: "L_APRV_RQST_DT" },
    },
};

// Approval History Form !== 결재 이력 폼 ==!
export const SF_APRV_HIST_INFO: TFormSchema = {
    id: "form_aprvHistInfo",
    schema: {
        aprvId: { type: "text", label: "L_APRV_ID" },
        lastAprvYnNm: { type: "text", label: "L_APRV_PRCSS_STAT_CD", readOnly: true },
        aprvPrcssOpinCn: { type: "textarea", label: "L_APRV_PRCS_OPIN_CN" },
        usrNm: { type: "text", label: "L_APRV_USR" },
        aprvPrcssDtm: { type: "datetime", label: "L_APRV_PRCSS_DT", readOnly: true },
        bsopClsfCd: { type: "text", label: "L_BSOP_CLSF_CD" },
        aprvBsopClsfCd: { type: "text", label: "L_APRV_BSOP_CLSF_CD", readOnly: true },
        usrDmnId: { type: "text", label: "L_USR_DMN_ID" },
        aprvPrcssMetdCd: { type: "text", label: "L_APRV_PRCSS_METD_CD" },
        cstmOfcrCd: { type: "code", label: "L_CSTM_OFCR_CD", area: "cstmOfcrCd", popupSize: "md" },
        aprvPrcssSeq: { type: "text", label: "L_SEQ", readOnly: true },
        orgUsrId: { type: "text" },
        orgUsrNm: { type: "text", label: "L_APRV_USR", disabled: true },
    },
};

// Approval Processing Status Form !== 결재 처리 폼 ==!
export const SF_APRV_PRCS_INFO: TFormSchema = {
    id: "form_aprvPrcsInfo",
    schema: {
        lastAprvYn: { type: "radio", label: "L_APRV_PRCSS_STAT_CD", options: lastAprvYn, required: true },
        aprvId: { type: "text", label: "L_APRV_ID" },
        aprvPrcssOpinCn: { type: "textarea", label: "L_APRV_PRCS_OPIN_CN", rows: 3, controlSize: 10 },
        bsopClsfCd: { type: "text", label: "L_BSOP_CLSF_CD" },
        scrnDocCd: { type: "text", label: "L_APRV_BSOP_CLSF_NM", readOnly: true },
        usrDmnId: { type: "text", label: "L_USR_DMN_ID" },
        usrNm: { type: "text", label: "L_RQST_USER_NM" },
        aprvPrcssDtm: { type: "datetime", label: "L_APRV_RQST_DT" },
        aprvPrcssOrd: { type: "text", label: "L_APRV_RQST_DT" },
        afPrcssUrlAddr: { type: "text", label: "L_AF_URL_ADDR" },
    },
};

// Organization User List Form !== 기관 사용자 목록 폼 ==!
export const SF_ORG_USR_LIST: TFormSchema = {
    id: "form_orgUsrList",
    schema: {
        orgCd: { type: "text" },
        aprvId: { type: "text" },
        deptNm: { type: "text", label: "L_DEPT_NM", letterCase: "upper" },
        usrNm: { type: "text", label: "L_USR_NM", letterCase: "upper" },
    },
};

// Waitting for approval Status Grid Schema !== 결재 대기 상태 목록 그리드 스키마  ==!
export const SG_APRV_WAIT_LIST: TGridSchema = {
    id: "grid_aprvWaitList",
    options: { pagination: "out", index: true, checkbox: false },
    head: [
        { cells: [{ header: "L_BSOP_CLSF_NM", binding: "bsopClsfCdNm", width: "15%" }] },
        { cells: [{ header: "L_APRV_RQST_TTLE_NM", binding: "aprvRqstTtleNm", width: "*" }] },
        { cells: [{ header: "L_DOC_NO", binding: "docNo", width: "15%" }] },
        { cells: [{ header: "L_APRV_STAT_CD", binding: "aprvPrcssStatCd", width: 0 }], show: false },
        { cells: [{ header: "L_PRCSS_STTS", binding: "aprvPrcssStatCdNm", width: "15%" }] },
        { cells: [{ header: "L_APRV_PRCSS_METD_CD", binding: "aprvPrcssMetdCdNm", width: 0 }], show: false },
        { cells: [{ header: "L_APRV_USR_NM", binding: "usrNm", width: "15%" }] },
        { cells: [{ header: "L_RQST_DTM", binding: "aprvRqstDtm", width: "15%" }] },
        { cells: [{ header: "L_APRV_ID", binding: "aprvId" }], show: false },
    ],
    body: [
        { cells: [{ binding: "bsopClsfCdNm", edit: false, align: "left" }] },
        { cells: [{ binding: "aprvRqstTtleNm", edit: false, align: "left" }] },
        { cells: [{ binding: "docNo", edit: false }] },
        { cells: [{ binding: "aprvPrcssStatCd", edit: false }] },
        { cells: [{ binding: "aprvPrcssStatCdNm", edit: false, align: "left" }] },
        { cells: [{ binding: "aprvPrcssMetdCdNm", edit: false }] },
        { cells: [{ binding: "usrNm", edit: false, align: "left" }] },
        { cells: [{ binding: "aprvRqstDtm", edit: false, type: "datetime" }] },
    ],
};

//  approval in Progress Status Grid Schema !== 결재 진행중 목록 그리드 스키마  ==!
export const SG_APRV_PRCD_LIST: TGridSchema = {
    id: "grid_aprvPrcdList",
    options: { pagination: "out", index: true, checkbox: false },
    head: [
        { cells: [{ header: "L_BSOP_CLSF_NM", binding: "bsopClsfCdNm", width: "15%" }] },
        { cells: [{ header: "L_APRV_RQST_TTLE_NM", binding: "aprvRqstTtleNm", width: "*" }] },
        { cells: [{ header: "L_DOC_NO", binding: "docNo", width: "15%" }] },
        { cells: [{ header: "L_APRV_STAT_CD", binding: "aprvPrcssStatCd", width: 0 }], show: false },
        { cells: [{ header: "L_PRCSS_STTS", binding: "aprvPrcssStatCdNm", width: "15%" }] },
        { cells: [{ header: "L_APRV_PRCSS_METD_CD", binding: "aprvPrcssMetdCdNm", width: 0 }], show: false },
        { cells: [{ header: "L_APRV_USR_NM", binding: "usrNm", width: "15%" }] },
        { cells: [{ header: "L_RQST_DTM", binding: "aprvRqstDtm", width: "15%" }] },
        { cells: [{ header: "L_APRV_ID", binding: "aprvId", width: "*" }], show: false },
    ],
    body: [
        { cells: [{ binding: "bsopClsfCdNm", edit: false, align: "left" }] },
        { cells: [{ binding: "aprvRqstTtleNm", edit: false, align: "left" }] },
        { cells: [{ binding: "docNo", edit: false }] },
        { cells: [{ binding: "aprvPrcssStatCd", edit: false }] },
        { cells: [{ binding: "aprvPrcssStatCdNm", edit: false, align: "left" }] },
        { cells: [{ binding: "aprvPrcssMetdCdNm", edit: false }] },
        { cells: [{ binding: "usrNm", edit: false, align: "left" }] },
        { cells: [{ binding: "aprvRqstDtm", edit: false }] },
    ],
};

// Completed Approval Status Grid Schema !== 결재 완료 목록 그리드 스키마  ==!
export const SG_APRV_CMPT_LIST: TGridSchema = {
    id: "grid_aprvCmptList",
    options: { pagination: "out", index: true, checkbox: false },
    head: [
        { cells: [{ header: "L_BSOP_CLSF_NM", binding: "bsopClsfCdNm", width: "15%" }] },
        { cells: [{ header: "L_APRV_RQST_TTLE_NM", binding: "aprvRqstTtleNm", width: "*" }] },
        { cells: [{ header: "L_DOC_NO", binding: "docNo", width: "15%" }] },
        { cells: [{ header: "L_APRV_STAT_CD", binding: "aprvPrcssStatCd", width: 0 }], show: false },
        { cells: [{ header: "L_PRCSS_STTS", binding: "aprvPrcssStatCdNm", width: "15%" }] },
        { cells: [{ header: "L_APRV_PRCSS_METD_CD", binding: "aprvPrcssMetdCdNm", width: 0 }], show: false },
        { cells: [{ header: "L_APRV_USR_NM", binding: "usrNm", width: "15%" }] },
        { cells: [{ header: "L_RQST_DTM", binding: "aprvRqstDtm", width: "15%" }] },
        { cells: [{ header: "L_APRV_ID", binding: "aprvId", width: "*" }], show: false },
    ],
    body: [
        { cells: [{ binding: "bsopClsfCdNm", edit: false, align: "left" }] },
        { cells: [{ binding: "aprvRqstTtleNm", edit: false, align: "left" }] },
        { cells: [{ binding: "docNo", edit: false }] },
        { cells: [{ binding: "aprvPrcssStatCd", edit: false }] },
        { cells: [{ binding: "aprvPrcssStatCdNm", edit: false, align: "left" }] },
        { cells: [{ binding: "aprvPrcssMetdCdNm", edit: false }] },
        { cells: [{ binding: "usrNm", edit: false, align: "left" }] },
        { cells: [{ binding: "aprvRqstDtm", edit: false, type: "datetime" }] },
    ],
};

// Request list for approval Status Grid Schema !== 결재 요청 상태 목록 그리드 스키마  ==!
export const SG_APRV_RQST_LIST: TGridSchema = {
    id: "grid_aprvRqstList",
    options: { pagination: "out", index: true, checkbox: false },
    head: [
        { cells: [{ header: "L_BSOP_CLSF_NM", binding: "bsopClsfCdNm", width: "15%" }] },
        { cells: [{ header: "L_APRV_RQST_TTLE_NM", binding: "aprvRqstTtleNm", width: "*" }] },
        { cells: [{ header: "L_DOC_NO", binding: "docNo", width: "15%" }] },
        { cells: [{ header: "L_APRV_STAT_CD", binding: "aprvPrcssStatCd", width: 0 }], show: false },
        { cells: [{ header: "L_PRCSS_STTS", binding: "aprvPrcssStatCdNm", width: "15%" }] },
        { cells: [{ header: "L_APRV_PRCSS_METD_CD", binding: "aprvPrcssMetdCdNm", width: 0 }], show: false },
        { cells: [{ header: "L_APRV_USR_NM", binding: "usrNm", width: "15%" }] },
        { cells: [{ header: "L_RQST_DTM", binding: "aprvRqstDtm", width: "15%" }] },
        { cells: [{ header: "L_APRV_ID", binding: "aprvId", width: "*" }], show: false },
    ],
    body: [
        { cells: [{ binding: "bsopClsfCdNm", edit: false, align: "left" }] },
        { cells: [{ binding: "aprvRqstTtleNm", edit: false, align: "left" }] },
        { cells: [{ binding: "docNo", edit: false }] },
        { cells: [{ binding: "aprvPrcssStatCd", edit: false }] },
        { cells: [{ binding: "aprvPrcssStatCdNm", edit: false, align: "left" }] },
        { cells: [{ binding: "aprvPrcssMetdCdNm", edit: false }] },
        { cells: [{ binding: "usrNm", edit: false, align: "left" }] },
        { cells: [{ binding: "aprvRqstDtm", edit: false, type: "datetime" }] },
    ],
};

//  approval in Progress Status Grid Schema !== 결재 이력 목록 그리드 스키마  ==!
export const SG_APRV_HIST_LIST: TGridSchema = {
    id: "grid_aprvHistList",
    options: { index: true, checkbox: false, height: 200 },
    head: [
        { cells: [{ header: "L_APRV_PRCSS_ORD", binding: "aprvPrcssOrd", width: 100 }] },
        { cells: [{ header: "L_APRV_ID", binding: "aprvId", width: "*" }], show: false },
        //{ cells: [{ header: "L_BSOP_CLSF_CD", binding: "bsopClsfCd", width: 200 }] },
        //{ cells: [{ header: "L_APRV_RQST_TTLE_NM", binding: "aprvRqstTtleNm", width: "*" }] },
        { cells: [{ header: "L_APRV_USR", binding: "usrNm", width: 300 }] },
        // { cells: [{ header: "L_CSTM", binding: "cstmNm", width: "*" }] },
        { cells: [{ header: "L_DEPT", binding: "deptNm", width: "*" }] },
        { cells: [{ header: "L_APRV_TP", binding: "aprvPrcssMetdCdNm", width: 200 }] },
        { cells: [{ header: "L_APRV_PRCSS_USR_YN", binding: "aprvPrcssUsrYn", width: 200 }] },
        { cells: [{ header: "L_APRV_STAT_CD", binding: "aprvPrcssStatCd", width: 300 }], show: false },
    ],
    body: [
        { cells: [{ binding: "aprvPrcssOrd", edit: false }] },
        { cells: [{ binding: "aprvId", edit: false }] },
        //{ cells: [{ binding: "bsopClsfCd", edit: false }] },
        //{ cells: [{ binding: "aprvRqstTtleNm", edit: false, align: "left" }] },
        { cells: [{ binding: "usrNm", edit: false, align: "left" }] },
        // { cells: [{ binding: "cstmNm", edit: false, align: "left" }] },
        { cells: [{ binding: "deptNm", edit: false, align: "left" }] },
        { cells: [{ binding: "aprvPrcssMetdCdNm", edit: false, align: "center" }] },
        { cells: [{ binding: "aprvPrcssUsrYn", edit: false, align: "center" }] },
        { cells: [{ binding: "aprvPrcssStatCd", edit: false, align: "left" }] },
    ],
};

//  Organization User Grid Schema !== 기관 사용자 목록 그리드 스키마  ==!
export const SG_ORG_USR_LIST: TGridSchema = {
    id: "grid_orgUsrList",
    options: { index: true, checkbox: false, pagination: "out" },
    head: [
        { cells: [{ header: "L_USR_ID", binding: "usrIdntfNo", width: 150 }] },
        { cells: [{ header: "L_USR_NM", binding: "usrNm", width: "*" }] },
        { cells: [{ header: "L_DEPT", binding: "deptNm", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "usrIdntfNo", edit: false }] },
        { cells: [{ binding: "usrNm", edit: false, align: "left" }] },
        { cells: [{ binding: "deptNm", edit: false, align: "left" }] },
    ],
};
